import styled from "styled-components";
import { H3 } from "../../../common";

export const Name = styled(H3)`
  color: ${({ theme }) => theme.colors.textColor};
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;
